import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-global-settings-title-horizontal-line',
  templateUrl: './global-settings-title-horizontal-line.component.html',
  styleUrls: ['./global-settings-title-horizontal-line.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(90deg)' })),
      state('rotated', style({ transform: 'rotate(-90deg)' })),
      transition('rotated => default', animate('200ms ease-out')),
      transition('default => rotated', animate('200ms ease-in')),
    ]),
  ],
})
export class GlobalSettingsTitleHorizontalLineComponent {
  @Input() text!: string;
  @Input() displayCarryOverFilter: boolean = false;
  @Output() carryOverChange = new EventEmitter<boolean>();
  filterOnlyCarryOver: boolean = false;
  @Input() showExpansionIndicator = false;
  @Input() expanded = false;
  @Output() expansionClick = new EventEmitter();

  onShowCarryOverChange() {
    this.carryOverChange.emit(this.filterOnlyCarryOver);
  }

  onExpansionClick() {
    this.expansionClick?.emit();
  }
}
